module.exports = "/_next/static/media/b21f3d83b55a75aeaab093bbe6e0b5db.svg";